import React, { useEffect, useRef } from 'react';
import { AlertTriangleIcon } from 'lucide-react';
interface DeleteConfirmDialogProps {
  itemNoun: string;
  onCancel: () => void;
  onArchive: () => void;
  onDelete: () => void;
}
export function DeleteConfirmDialog({
  itemNoun,
  onCancel,
  onArchive,
  onDelete
}: DeleteConfirmDialogProps) {
  const cancelRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    cancelRef.current?.focus();
  }, []);
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        onCancel();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onCancel]);
  return <div className="fixed inset-0 z-50 flex items-center justify-center" role="dialog" aria-modal="true" aria-labelledby="delete-dialog-title" data-id="element-178">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/20 backdrop-blur-[2px]" onClick={onCancel} aria-hidden="true" data-id="element-179" />

      {/* Dialog */}
      <div className="relative bg-white rounded-none shadow-xl border border-stone-200 w-full max-w-sm mx-4 overflow-hidden animate-in fade-in zoom-in-95 duration-150" data-id="element-180">
        <div className="px-5 pt-5 pb-4" data-id="element-181">
          <div className="flex items-start gap-3" data-id="element-182">
            <div className="flex-shrink-0 w-9 h-9 rounded-none bg-red-50 flex items-center justify-center" data-id="element-183">
              <AlertTriangleIcon className="w-4.5 h-4.5 text-red-500" data-id="element-184" />
            </div>
            <div className="pt-0.5" data-id="element-185">
              <h2 id="delete-dialog-title" className="text-sm font-semibold text-stone-900" data-id="element-186">
                Delete {itemNoun}
              </h2>
              <p className="text-sm text-stone-500 mt-1 leading-relaxed" data-id="element-187">
                Are you sure you'd like to delete this {itemNoun}?
              </p>
            </div>
          </div>
        </div>

        <div className="px-5 pb-4 flex flex-col gap-2" data-id="element-188">
          <button ref={cancelRef} onClick={onCancel} className="w-full px-3 py-2 text-sm font-medium rounded-none bg-stone-900 text-white hover:bg-stone-800 transition-colors duration-100 focus:outline-none focus:ring-2 focus:ring-stone-900 focus:ring-offset-2" data-id="element-189">
            Never mind, don't delete it
          </button>
          <button onClick={onArchive} className="w-full px-3 py-2 text-sm font-medium rounded-none border border-stone-200 text-stone-700 bg-white hover:bg-stone-50 transition-colors duration-100 focus:outline-none focus:ring-2 focus:ring-stone-400 focus:ring-offset-2" data-id="element-190">
            Archive {itemNoun}
          </button>
          <button onClick={onDelete} className="w-full px-3 py-2 text-sm font-medium rounded-none text-red-600 bg-red-50 hover:bg-red-100 transition-colors duration-100 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2" data-id="element-191">
            Yes, delete {itemNoun}
          </button>
        </div>
      </div>
    </div>;
}